import { render, staticRenderFns } from "./WaybillDetailContent.vue?vue&type=template&id=51521f9e&"
import script from "./WaybillDetailContent.vue?vue&type=script&lang=js&"
export * from "./WaybillDetailContent.vue?vue&type=script&lang=js&"
import style0 from "./WaybillDetailContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports